import SiteLayout from "@/components/feature/SiteLayout";
import Seo, { JsonLd } from "@/components/feature/Seo";
import FaqSection from "@/components/feature/FaqSection";
import Hero from "./components/Hero";
import CategoryStrip from "./components/CategoryStrip";
import LiveFeed from "./components/LiveFeed";
import TopicFeed from "./components/TopicFeed";
import OnSceneStrip from "./components/OnSceneStrip";
import SubscribeBand from "./components/SubscribeBand";
import { articles, categories, faqs } from "@/mocks/news";

export default function Home() {
  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "独家吃瓜",
    url: "https://wxtmhb.cn/",
    description:
      "独家吃瓜是聚焦娱乐快讯的中文资讯门户，汇总明星八卦、综艺爆料、影视动态与网红热榜今日最新动态，实时滚动播报。",
    inLanguage: "zh-CN",
    publisher: {
      "@type": "Organization",
      name: "独家吃瓜",
    },
    potentialAction: {
      "@type": "SearchAction",
      target: "https://wxtmhb.cn/news?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  const itemListSchema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "今日热门娱乐快讯",
    itemListElement: articles.slice(0, 8).map((article, index) => ({
      "@type": "ListItem",
      position: index + 1,
      url: `https://wxtmhb.cn/article/${article.id}`,
      name: article.title,
    })),
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  };

  return (
    <>
      <Seo
        title="独家吃瓜 - 今日最新动态与娱乐快讯滚动播报"
        description="独家吃瓜汇总今日最新娱乐动态，明星八卦、综艺爆料、影视定档与网红热榜滚动播报，现场直击一页看完，随时刷新随时有料。"
        keywords="独家吃瓜,独家吃瓜今日,娱乐快讯,明星八卦,综艺爆料,影视动态,网红热榜"
        path="/"
      />
      <JsonLd data={webPageSchema} />
      <JsonLd data={itemListSchema} />
      <JsonLd data={faqSchema} />
      <SiteLayout>
        <Hero />
        <CategoryStrip />
        <LiveFeed />
        <TopicFeed
          title="按方向浏览最新内容"
          subtitle="四个分类覆盖娱乐资讯的主要方向，点一下切换，找到你真正关心的那类动态。"
          categories={categories.map((category) => ({ slug: category.slug, name: category.name }))}
          articles={articles}
        />
        <OnSceneStrip />
        <FaqSection />
        <SubscribeBand />
      </SiteLayout>
    </>
  );
}